import { SegmentKey, } from '@zurich/api/claim';
import { enumWithStringValuesToArrayOfKeys, getStreetNumberComposite, } from '@zurich/common/types';
// TODO: rewrite with typeUtils (@zurich/common/utils)
export var ClaimTrackingPoints;
(function (ClaimTrackingPoints) {
    //TODO: replace with enum
    ClaimTrackingPoints.getTranslatedValue = (value, t) => {
        if (value)
            return t(`claim:trackId.${value}`);
        return null;
    };
})(ClaimTrackingPoints || (ClaimTrackingPoints = {}));
// TODO: change to ClaimZdbStatus
// TODO: rewrite with typeUtils (@zurich/common/utils)
export var ClaimZdbStatus;
(function (ClaimZdbStatus) {
    function getTranslatedValue(value, t) {
        return t(`claim:status.${value}`) ?? value;
    }
    ClaimZdbStatus.getTranslatedValue = getTranslatedValue;
})(ClaimZdbStatus || (ClaimZdbStatus = {}));
// TODO: rewrite with typeUtils (@zurich/common/utils)
export var ClaimAddress;
(function (ClaimAddress) {
    ClaimAddress.getFullAddress = (participant) => `${participant.postalCode} ${participant.city}, ${getStreetNumberComposite(participant.streetName, participant.streetNo, participant.floorNo, participant.doorNo)}`;
})(ClaimAddress || (ClaimAddress = {}));
export const getClaimParticipantRole = (participantRole, participantGroup, t) => t(`claim:participantRole.${participantRole}`, {
    context: participantGroup === '1' ? '1' : '!1',
});
// TODO: rewrite with typeUtils (@zurich/common/utils)
export var ClaimLegacyDescription;
(function (ClaimLegacyDescription) {
    function getTranslatedValue(value, t) {
        // we set no namespace on purpose as it is in claim-search and claim
        return value ? t(`legacyDescription.${value}`, '') : value;
    }
    ClaimLegacyDescription.getTranslatedValue = getTranslatedValue;
})(ClaimLegacyDescription || (ClaimLegacyDescription = {}));
export const getClaimInsuranceSegmentTranslatedValue = (value, _t) => {
    if (value) {
        return value.split('_').pop();
    }
    return undefined;
};
export const getClaimInsuranceSegmentOptions = (t) => {
    const insuranceSegments = enumWithStringValuesToArrayOfKeys(SegmentKey);
    return insuranceSegments.map((segment) => ({
        label: getClaimInsuranceSegmentTranslatedValue(segment, t) ?? '',
        value: segment,
    }));
};
